import type { RichText } from '@backmarket/http-api/src/api-specs-content/models/rich-text'
import { BLOCKS } from '@contentful/rich-text-types'

export function buildSimpleRichText(
  text: string,
  heading: 'h2' | 'p',
): RichText {
  return {
    content: [
      {
        content: [
          {
            data: {},
            marks: [],
            nodeType: 'text',
            value: text,
          },
        ],
        data: {},
        nodeType: heading === 'h2' ? BLOCKS.HEADING_2 : BLOCKS.PARAGRAPH,
      },
    ],
    data: {},
    nodeType: BLOCKS.DOCUMENT,
  }
}
